import { Badge } from "@/components/ui/badge";
import { Flame } from "lucide-react";
import { catMeta, impMeta, statusMeta, confMeta, srcMeta } from "@/lib/catalysts";

const Pill = ({ meta, testId, children }) => (
  <Badge variant="outline" className="bg-transparent text-[9px] uppercase" style={{ borderColor: meta.color + "66", color: meta.color }} data-testid={testId}>
    {children || meta.label}
  </Badge>
);

export function CategoryBadge({ e }) { return <Pill meta={catMeta(e.category)} />; }
export function ImpactBadge({ e }) { return <Pill meta={impMeta(e.impact)} />; }
export function SourceBadge({ e }) {
  const m = srcMeta(e.source);
  return <Pill meta={m} testId={e.source === "auto" ? `auto-badge-${e.id}` : `source-badge-${e.id}`}>{m.label}</Pill>;
}
export function StatusBadge({ e }) {
  if (!e.status || e.status === "scheduled") return null;
  return <Pill meta={statusMeta(e.status)} testId={`status-badge-${e.id}`} />;
}
export function ConfidenceBadge({ e }) {
  if (!e.confidence) return null;
  return <Pill meta={confMeta(e.confidence)} testId={`confidence-badge-${e.id}`} />;
}
export function ViralBadge({ e }) {
  if (!e.viral) return null;
  return (
    <Badge variant="outline" className="bg-orange-500/10 text-[9px] uppercase border-orange-500/50 text-orange-300 gap-0.5" data-testid={`viral-badge-${e.id}`}>
      <Flame className="h-2.5 w-2.5" /> Viral
    </Badge>
  );
}

export function EventBadges({ e, withSource = true }) {
  return (
    <>
      <ViralBadge e={e} />
      <CategoryBadge e={e} />
      <ImpactBadge e={e} />
      <StatusBadge e={e} />
      {withSource && <SourceBadge e={e} />}
    </>
  );
}
